import { render, staticRenderFns } from "./ServiceQualificationNbn.vue?vue&type=template&id=1ada1396&scoped=true"
import script from "./ServiceQualificationNbn.vue?vue&type=script&lang=js"
export * from "./ServiceQualificationNbn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada1396",
  null
  
)

export default component.exports